import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { faFile } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  PixelCurrency,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'

import { getVendorsBalance } from 'utils/api-routes.util'

interface IVendorBalance {
  vendor_id: number | string
  name: string
  vendor_type: string
  order_total_amount: number
  order_commission_amount: number
}

interface IVendorBalanceResponse {
  response: {
    data: IVendorBalance[]
  }
}

const breadcrumbs = [
  {
    name: 'Vendors',
    active: true,
  },
]

const Dashboard = () => {
  const navigate = useNavigate()

  const [vendorBalance, setVendorBalance] = React.useState<IVendorBalance[]>([])
  const [tableLoading, setTableLoading] = React.useState(true)
  const getPayableReceivables = () => {
    setTableLoading(true)
    getVendorsBalance().subscribe((res: IVendorBalanceResponse) => {
      setVendorBalance(res.response.data)
      setTableLoading(false)
    })
  }

  useEffect(() => {
    getPayableReceivables()
  }, [])
  const actions = [
    {
      title: 'View Details',
      icon: (
        <>
          <Section>
            <PixelIcon icon={faFile} />
          </Section>
        </>
      ),
      clickHandler: (row) => {
        navigate(`/vendors/payments/${row.vendor_id}`)
      },
    },
  ]

  const columns = [
    {
      dataKey: 'name',
      name: 'Vendor Name',
      sortable: true,
      selector: (row) => row.name || '--',
    },
    {
      dataKey: 'vendor_type',
      name: 'Vendor Type',
      sortable: true,
      selector: (row) => row.vendor_type || '--',
    },
    {
      dataKey: 'order_total_amount',
      name: 'Total Amount',
      sortable: true,
      selector: (row) => (
        <PixelCurrency value={row.order_total_amount} currency={'USD'} />
      ),
    },
    {
      dataKey: 'order_commission_amount',
      name: 'Commission',
      sortable: true,
      selector: (row) => (
        <span
          style={{
            color:
              row.order_commission_amount < 0
                ? 'red'
                : row.order_commission_amount === 0
                ? 'black'
                : 'green',
            fontWeight: 'bold',
          }}
        >
          <PixelCurrency value={row.order_commission_amount} currency={'USD'} />
        </span>
      ),
    },

    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]

  return (
    <>
      <DcFlexBox height="60px" style={{ fontSize: '16px', padding: '8px 0px' }}>
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <PixelPageContainer padding="0px">
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={vendorBalance}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default Dashboard
